import { render, staticRenderFns } from "./modal-order-product-details.vue?vue&type=template&id=21eb0cf0&scoped=true"
import script from "./modal-order-product-details.vue?vue&type=script&lang=js"
export * from "./modal-order-product-details.vue?vue&type=script&lang=js"
import style0 from "./modal-order-product-details.vue?vue&type=style&index=0&id=21eb0cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eb0cf0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseLink.vue').default,BaseTag: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseTag.vue').default,BaseButton: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseButton.vue').default})
